import { render } from "./ViewTransfertMagasin.vue?vue&type=template&id=8fb3820a&ts=true"
import script from "./ViewTransfertMagasin.vue?vue&type=script&lang=ts"
export * from "./ViewTransfertMagasin.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__